import React from "react";

import { SpacingToken } from "@livechat/design-system-react-components";

import Flex from "components/layout/Flex";
import { NAVIGATION_GROUPS } from "constants/settings/navigationItems";
import { withVar } from "themes/helpers";

import { NavigationGroup } from "./NavigationGroup";
import { ISettingsSideNavigationItemWithBadge } from "./interfaces";

interface IProps {
  navigationItems: ISettingsSideNavigationItemWithBadge[];
  activeItem: string;
}

export const NavigationItems: React.FC<IProps> = ({ navigationItems, activeItem }) => (
  <Flex
    column
    gap={withVar(SpacingToken.Spacing4)}
    paddingV={withVar(SpacingToken.Spacing6)}
    paddingH={withVar(SpacingToken.Spacing6)}
  >
    {NAVIGATION_GROUPS.map(group => (
      <NavigationGroup
        key={group}
        group={group}
        items={navigationItems.filter(item => item.group === group)}
        activeItem={activeItem}
      />
    ))}
  </Flex>
);
